// extracted by mini-css-extract-plugin
export default {"sortIcon":"icons-module__sortIcon__TE1Bosb"};